// Headshot assets for the booking-step account managers, keyed by AM key.
// Sourced from the 2026-05-07 onboarding prototype; swap for final art later.
import { AmKey } from '../../view-model/amProfiles';
import brookeHeadshot from './assets/brooke.png';
import klaberaHeadshot from './assets/klabera.png';

export const AM_HEADSHOTS: Record<AmKey, string> = {
  brooke: brookeHeadshot,
  klabera: klaberaHeadshot,
};
